export function dateWithoutTimePart(date: Date): Date {
	const year = date.getFullYear();
	const month = datePartToStringRepresentation(date.getMonth() + 1);
	const day = datePartToStringRepresentation(date.getDate());
	return new Date("" + year + "-" + month + "-" + day);
}

function datePartToStringRepresentation(monthNumber: number): string {
	if (monthNumber < 10) {
		return "0" + monthNumber;
	}
	return "" + monthNumber;
}

/**
 * @param dateStr YYYY-MM-DD
 */
export function dateWithoutTime(date: Date | string): Date {
	if (date == null) {
		return null;
	}

	const tmp = date instanceof Date ? date : new Date(date);
	const timeZoneOffsetMillis = tmp.getTimezoneOffset() * 60 * 1000;
	const currentTimeMillis: number = date instanceof Date ? date.getTime() : Date.parse(date);
	return new Date(currentTimeMillis + timeZoneOffsetMillis);
}

export function dateToString(date: Date): string {
	const year = date.getFullYear();
	const month = datePartToStringRepresentation(date.getMonth() + 1);
	const day = datePartToStringRepresentation(date.getDate());
	return `${year}-${month}-${day}`;
}

export function isInPast(date: Date): boolean {
	if (date == null) {
		return false;
	}

	const now: Date = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	return date.getTime() < today.getTime();
}

export function isBeforeOrNull(date1: Date | string, date2: Date | string) {
	return date1 == null || date2 == null ? true : new Date(date1).getTime() < new Date(date2).getTime();
}

export function GMTToLocalDateTime(date): Date {
	if (date) {
		date = new Date(date);
		const offset = new Date().getTimezoneOffset();
		date.setMinutes(date.getMinutes() - offset);
	}
	return date;
}
